import { find } from 'lodash/fp';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSnackbar } from 'notistack';
import { Requests } from './Requests';
import { Box, Grid } from '@mui/material';
import { AspectsAccordion } from './AspectsAccordion';
import { IFIBreadcrumbs } from './Breadcrumbs';
import { RequestSkeleton } from './Skeleton/RequestSkeleton';
import { useAxios } from './util/use-axios';
import { IGotItDialog } from './IGotItDialog';

const getCacheSelectedAspects = () => {
  const cacheSelectedAspects =
    localStorage.aspectParams?.length > 0 ? localStorage.aspectParams : '{}';

  return JSON.parse(cacheSelectedAspects);
};

const CaseRequests = (props) => {
  const isEvent = props.requestType === 'Event';

  const { enqueueSnackbar } = useSnackbar();

  const [requests, setRequests] = useState([]);
  const [aspects, setAspects] = useState([]);

  const { loading, axiosHttp } = useAxios();
  const [showThankyouDialog, setShowdialog] = useState(false);
  const signupSuccessMessage = useRef('');
  const scrollPos = useRef(0);

  const scrollToCard = useCallback(() => {
    const { hash } = props.location || {};
    if (hash?.length > 0) {
      const hashReq = find(({ Id }) => hash === `#_${Id}`, requests);
      if (hashReq) {
        var elmnt = document.getElementById(`_${hashReq.Id}`);
        if (elmnt) elmnt.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.scrollTo({
        top: sessionStorage.scrollTop,
        behavior: 'smooth',
      });
    }
  }, [props.location, requests]);

  useEffect(() => {
    if (!sessionStorage.scrollTop) {
      sessionStorage.scrollTop = scrollPos.current;
    }
    window.addEventListener('scroll', () => {
      scrollPos.current = document.documentElement.scrollTop;
    });
    return () => {
      sessionStorage.scrollTop = scrollPos.current;
      window.removeEventListener('scroll', () => {});
    };
  }, []);

  useEffect(() => {
    setTimeout(scrollToCard, 200);
  }, [scrollToCard]);

  const handleAspectsChange = (newParams) => {
    localStorage.aspectParams = JSON.stringify(newParams);
    getRequests();
  };

  const getRequests = useCallback(async () => {
    try {
      const params = getCacheSelectedAspects();

      const result = await axiosHttp(
        isEvent ? '/api/events' : '/api/requests',
        { params },
      );
      const { records, aspects } = result.data || {};
      setRequests(records);
      setAspects(aspects);
    } catch (err) {
      enqueueSnackbar(err.message, { variant: 'error' });
    }
  }, [axiosHttp, enqueueSnackbar, isEvent]);

  const actionPerform = (url, payload, isSignUpRequest) => {
    axiosHttp(url, { method: 'post', payload: payload || {} })
      .then((res) =>
        getRequests()
          .then(() => {
            const successMessage =
              res?.data?.message ?? 'your request is succesfully completed';

            return successMessage;
          })
          .then((message) => {
            if (
              isSignUpRequest &&
              localStorage.iGotItOnSignUpThankYou !== 'true'
            ) {
              signupSuccessMessage.current = message;
              setShowdialog(true);
            } else {
              enqueueSnackbar(message, { variant: 'success' });
            }
          }),
      )
      .catch((err) => enqueueSnackbar(err.message, { variant: 'error' }));
  };

  useEffect(getRequests, [getRequests]);

  return (
    <section>
      {loading ? (
        <RequestSkeleton />
      ) : (
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <IFIBreadcrumbs
                breadcrumbs={[
                  { name: isEvent ? 'Events' : 'Student Requests' },
                ]}
              />
            </Grid>
            <Grid item xs={12} lg={3} style={{ width: '100%' }}>
              <AspectsAccordion
                aspects={aspects}
                handleAspectsChange={handleAspectsChange}
              />
            </Grid>
            <Grid item xs={12} lg={9} style={{ width: '100%' }}>
              <Requests
                requests={requests}
                actionPerform={actionPerform}
                requestType={props.requestType}
              />
            </Grid>
          </Grid>
        </Box>
      )}
      {showThankyouDialog && (
        <IGotItDialog
          successMessage={signupSuccessMessage.current}
          open={showThankyouDialog}
          setOpen={setShowdialog}
        />
      )}
    </section>
  );
};

export { CaseRequests };
